export const initialPeriod = {
  from: '',
  to: '',
};

const periods = (state, action) => {
  switch (action.type) {
    case 'ADD_PERIOD': {
      const periodsLength = state.periods.length;
      let nextPeriod = initialPeriod;

      if (state.periods.length >= 1) {
        nextPeriod = { ...state.periods[periodsLength - 1] };
      }

      // ограничение на показ только 5 доп. периодов
      const newPeriods = [...state.periods, nextPeriod].slice(0, 5);

      return {
        ...state,
        periods: newPeriods,
      };
    }

    case 'DELETE_PERIOD':
      return {
        ...state,
        periods: state.periods.filter((period, index) => action.index !== index),
      };

    case 'SET_PERIOD':
      return {
        ...state,
        periods: state.periods.map((period, index) => {
          return action.index === index
            ? {
                from: action.from,
                to: action.to,
              }
            : period;
        }),
      };

    case 'COPY_PERIODS': {
      let selfPeriods = [...state.periods];

      // если в стейте находится только один пустой период - удаляем его
      const isOnlyOnePeriod = state.periods.length === 1;
      const isEmptyFirstPeriod = state.periods[0].to === '';

      if (isOnlyOnePeriod && isEmptyFirstPeriod) {
        selfPeriods = [];
      }
      // ограничение на показ только 5 доп. периодов
      const newPeriods = [...selfPeriods, ...action.periods].slice(0, 5);

      return {
        ...state,
        periods: newPeriods,
      };
    }

    case 'SET_SHOW_PERIODS':
      return {
        ...state,
        isShow: action.value,
      };

    default:
      return state;
  }
};

export default periods;
